<template>
  <AutomationResultConfirmModal
      v-if="automationsPendingConfirmation"
      @close="$emit('close')"
      :visible="visible"
      :automations="automationsPendingConfirmation"
  />
</template>

<script>
import AutomationResultConfirmModal from '~/pages/automation/components/result/AutomationResultConfirmModal.vue'
import automationInterfaceApi from '~/api/automation_interface'

export default {
  name: 'AllResultsConfirmModal',
  components: { AutomationResultConfirmModal },
  props: {
    visible: {
      type: Boolean,
    },
  },
  data() {
    return {
      automationsPendingConfirmation: null,
    }
  },
  created() {
    this.fetchAutomationsPendingConfirmation();
  },
  methods: {
    fetchAutomationsPendingConfirmation() {
      automationInterfaceApi.getPendingConfirmation([
        'search_thumbnail'
      ]).then((response) => {
        this.automationsPendingConfirmation = response.data || []
      })
    },
  },
}
</script>

<style scoped>

</style>
